import Table from "components/elements/Table";
import {
  USER_BUSINESS_ADMIN,
  USER_CLIENT_ADMIN,
  USER_OPS,
  USER_SUPERADMIN,
  USER_TYPE_REVERSE,
} from "core/Constants";
import dataProvider from "core/DataProvider";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useOutletContext } from "react-router-dom";
import AddInternalUser from "./AddInternalUser";
import AddClientUser from "./AddClientUser";
import IconInput from "components/elements/IconInput";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
const { default: Header } = require("../Header");

const internalHeaderMap = {
  id: "ID",
  name: "Name",
  email: "Email",
  user_type: "User Type",
  status: "Status",
  created_on: "Created On",
  modified_on: "Modified On",
  last_login: "Last Login",
};

const clientHeaderMap = {
  id: "ID",
  name: "Name",
  email: "Email",
  user_type: "User Type",
  status: "Status",
};

const clientUserHeaderMap = {
  id: "ID",
  name: "Name",
  email: "Email",
  client_name: "Client Name",
  user_type: "User Type",
  status: "Status",
  created_on: "Created On",
  modified_on: "Modified On",
  last_login: "Last Login",
};

const internalUsersTypes = [USER_SUPERADMIN, USER_BUSINESS_ADMIN];
const clientUserTypes = [USER_CLIENT_ADMIN];

const UserManagement = () => {
  const { token } = useOutletContext();
  const { name, client_name } = token;

  const [internalUsers, setInternalUsers] = useState([]);
  const [clientUsers, setClientUsers] = useState([]);
  const [isearch, setISearch] = useState("");
  const [csearch, setCSearch] = useState("");
  const [iloading, setILoading] = useState(true);
  const [cloading, setCLoading] = useState(true);
  const [editUser, setEditUser] = useState(null);

  const isInternalUser = internalUsersTypes.includes(token.type);
  const isClientUser = clientUserTypes.includes(token.type);

  const fetchData = async () => {
    // internal users and client users
    try {
      let data = await dataProvider.network.get("masters/user");
      let iu = [];
      let cu = [];

      for (let i = 0; i < data.length; i++) {
        data[i].user_type_int = data[i].user_type;
        data[i].user_type = USER_TYPE_REVERSE[data[i].user_type];
        data[i].status = data[i].status ? "Active" : "Inactive";
        data[i].created_on = data[i].created_on
          ? new Date(data[i].created_on).toLocaleString()
          : "";
        data[i].modified_on = data[i].modified_on
          ? new Date(data[i].modified_on).toLocaleString()
          : "";
        data[i].last_login = data[i].last_login
          ? new Date(data[i].last_login).toLocaleString()
          : "";

        if (
          [USER_SUPERADMIN, USER_BUSINESS_ADMIN, USER_OPS].includes(
            data[i].user_type_int
          )
        ) {
          data[i].action = (
            <div
              className="action flex flex-v-center"
              onClick={() => {
                editInternalUser(data[i]);
              }}
            >
              <div className="action-button flex flex-center">
                <EditIcon />
              </div>
            </div>
          );
          iu.push(data[i]);
        } else {
          data[i].action = (
            <div
              className="action flex flex-v-center"
              onClick={() => {
                editClientUser(data[i]);
              }}
            >
              <div className="action-button flex flex-center">
                <EditIcon />
              </div>
            </div>
          );
          cu.push(data[i]);
        }
      }

      setInternalUsers(iu);
      setClientUsers(cu);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch users");
    } finally {
      setILoading(false);
      setCLoading(false);
    }
  };

  const editInternalUser = user => {
    setEditUser(user);
  };

  const editClientUser = user => {
    console.log("Editing user:", user);
    console.log("check", isClientUser);
    setEditUser(user);
  };

  const editCancel = () => {
    setEditUser(null);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div id="user-management" className="page">
      <Header user={name} client_name={client_name} title="User Management" />
      <section id="user-management-container">
        {isInternalUser && (
          <>
            <AddInternalUser
              onComplete={() => fetchData()}
              editUser={editUser}
              cancel={editCancel}
            />
            <div className="box mtop">
              <div className="flex flex-v-center">
                <h3 className="pad-lr">Internal Users</h3>
                <div className="right flex">
                  <div className="el">
                    {iloading && (
                      <div className="loader">
                        <div className="lds-hourglass"></div>
                      </div>
                    )}
                  </div>
                  <div className="el pad-lr">
                    <IconInput
                      value={isearch}
                      onChange={e => setISearch(e.target.value)}
                      placeholder="Search (min 3 character)"
                      icon="search"
                      style={{ minWidth: "250px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="mtop">
                <Table
                  headers={
                    isInternalUser
                      ? { action: "Actions", ...internalHeaderMap }
                      : internalHeaderMap
                  }
                  data={internalUsers}
                  search={isearch}
                />
              </div>
            </div>
            <div className="box mtop">
              <div className="flex flex-v-center">
                <h3 className="pad-lr">Client Users</h3>
                <div className="right flex">
                  <div className="el">
                    {cloading && (
                      <div className="loader">
                        <div className="lds-hourglass"></div>
                      </div>
                    )}
                  </div>
                  <div className="el pad-lr">
                    <IconInput
                      value={csearch}
                      onChange={e => setCSearch(e.target.value)}
                      placeholder="Search (min 3 character)"
                      icon="search"
                      style={{ minWidth: "250px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="mtop">
                <Table
                  headers={clientUserHeaderMap}
                  data={clientUsers}
                  search={csearch}
                />
              </div>
            </div>
          </>
        )}

        {isClientUser && (
          <>
            <AddClientUser
              onComplete={() => fetchData()}
              editUser={editUser}
              cancel={editCancel}
            />
            <div className="box mtop">
              <Table
                headers={
                  isClientUser
                    ? { action: "Actions", ...clientHeaderMap }
                    : clientHeaderMap
                }
                data={clientUsers}
              />
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default UserManagement;
